import api from "./index";

import cookiesHelper from "../helpers/cookies";

import { ISaveProgramFunction } from "../interfaces/services";

export const saveProgramFunction = async (data: ISaveProgramFunction) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`program-functions`, data);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};

export const deleteProgramFunction = async (id: number) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`program-functions/${id}`);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};